import {
  DATASTRATEGY,
  IEntityManagerConfiguration,
} from '@proximus/entity-manager';
import { SessionStorageStrategy } from '@proximus/entity-manager/lib/storage/strategies/session-storage.strategy';
import { LocalForageStrategy } from '@proximus/entity-manager/lib/storage/strategies/local-forage.strategy';
import { CryptoJsProviderStrategy } from '@proximus/entity-manager/lib/encryption/cryptoJsProviderStrategy';
import Cookies from 'js-cookie';
import packageInfo from '../../../package.json';

const ProductConfig: IEntityManagerConfiguration = {
  application: {
    applicationName: 'myProducts',
    applicationVersion: packageInfo.version,
    versionStorageStrategyId: LocalForageStrategy.ID,
    clearStorageIfVersionIsMissing: true,
  },
  storageStrategies: {
    localForage: new LocalForageStrategy(),
    sessionStorage: new SessionStorageStrategy(),
  },
  selectedEncryptionStrategy: CryptoJsProviderStrategy(),
  timeout: 10000,
  language: {
    selectLanguageFunction: () =>
      Cookies.get('LANGUAGE') || (<any>window).language || 'en',
    languageStorageStrategyId: LocalForageStrategy.ID,
  },
  defaultEntityConfiguration: {
    version: 'v1',
    dataStrategy: DATASTRATEGY.CACHE_NETWORK_NO_ERRORS,
    storageStrategy: LocalForageStrategy.ID,
  },
  jwtStorageStrategyId: SessionStorageStrategy.ID,
  onErrorCallback: () => {},
};

export { ProductConfig };
